import React, { useState, useEffect, useLayoutEffect } from "react";
import { rsaSchema, storeSchema, updateStoreSchema } from "../schema";
import { useFormik } from "formik";
import WebsitesService from "./Services/websites.service";
import StoreService from "./Services/store.service";
import RsaService from "./Services/rsa.service";
import { toast, ToastContainer } from "react-toastify";
import Navbar from "./Includes/Navbar";
import ReCAPTCHA from "react-google-recaptcha";
import { useParams } from "react-router-dom";

function EditStore() {
  const [info, setInfo] = useState({
    website: "",
    location: "",
    regions: "",
  });
  const [loading, setLoading] = useState(false);
  const [empErr, setEmpErr] = useState("");
  const [stores, setStores] = useState([]);
  const [websites, setWebsites] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [errorsCap, setErrorsCap] = useState(null);
  const [errorsCapMsg, setErrorsCapMsg] = useState("");
  const { id } = useParams();
  const selWeb = localStorage.getItem("site");

  // TODO
  const getInfoById = async (id, selWeb) => {
    const { data } = await StoreService.getStoreById(id, selWeb);
    const { response: res } = data;
    // console.log("data=" + JSON.stringify(res));
    info.website = res.site;
    info.location = res.store_location;
    info.regions = res.regions;
  };

  const getStoresList = async (url) => {
    const { data } = await StoreService.getStoreList(url);
    const { response: res } = data;
    console.log(data);
    setStores(res);
  };

  useLayoutEffect(() => {
    getInfoById(id, selWeb);
    getStoresList(selWeb);
  }, []);

  useEffect(() => {
    const getWebsitesList = async () => {
      const { data } = await WebsitesService.getWebsitesList();
      const { response: res } = data;
      console.log(data);
      const results = [];
      res.map((value) => {
        results.push({
          key: value.name,
          url: value.url,
          value: value.id,
        });
      });
      setWebsites([{ key: "Please Select", value: "" }, ...results]);
    };
    getWebsitesList();
  }, []);

  // const changeSite = (e) => {
  //   let site = e.target.value;
  //   setStores([]);
  //   setSelectedUrl(site);
  //   const getStoresList = async () => {
  //     const { data } = await StoreService.getStoreList(site);
  //     const { response: res } = data;
  //     console.log(data);
  //     setStores(res);
  //   };
  //   if (site !== "") {
  //     getStoresList();
  //   }
  // };

  const submitData = async (values) => {
    setLoading(true);
    setEmpErr("");
    try {
      const { data } = await StoreService.updateStore(id, values, selWeb);
      setLoading(false);
      toast.success("Record updated", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (err) {
      if (err?.response?.status === 409) {
        setEmpErr(err?.response?.data?.employee_id);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        // TODO conditional sites
        website: info.website,
        store_location: info.location,
        regions: info.regions,
      },
      // TODO conditional sites
      validationSchema: updateStoreSchema,
      onSubmit: (values, action) => {
        // console.log(values);
        // if (errorsCap !== null) {
        submitData(values);
        setErrorsCapMsg("");
        // } else {
        //   setErrorsCapMsg("Captcha is not verified");
        // }
      },
    });

  function onChange(value) {
    // console.log(value);
    setErrorsCap(value);
    if (value === null) {
      setErrorsCapMsg("Captcha is not verified");
    } else {
      setErrorsCapMsg("");
    }
  }
  const verifyCallback = (response) => {
    let errorsCap = {};
    if (response) {
    } else {
      return false;
    }
  };
  const onLoadRecaptcha = () => {};

  return (
    <>
      <Navbar />
      <div className="main-w3ls">
        <div className="left-content">
          <ToastContainer />
          <div className="overlay-left"></div>
          <div className="w3ls-content">
            <h1>
              <span className="fa fa-magic"></span>Need further assistance?
            </h1>

            <h2>Email Elite Rewards.</h2>
            <a href="mailto:ashley@eliterewards.biz" className="button-w3ls">
              {/* <span className="fa fa-long-arrow-right"></span> */}
              <span className="fa fa-envelope" aria-hidden="true"></span>
            </a>
          </div>
        </div>

        <div className="right-form-agile">
          <div className="sub-main-w3">
            <h3>Update Request</h3>
            <h5>Fill out our simple form</h5>
            <p>to add or remove an RSA from your store dropdown.</p>
            <form action="" onSubmit={handleSubmit}>
              <div className="form-style-agile">
                <label>Websites</label>
                <div className="pom-agile">
                  <span className="fa fa-globe"></span>
                  <select
                    onChange={(e) => {
                      // changeSite(e);
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    name="website"
                    required=""
                    value={values.website || ""}
                    disabled
                    style={{ filter: "opacity(0.6)" }}
                  >
                    {websites.map((res) => {
                      return (
                        <option key={res.value} value={res.url}>
                          {res.key}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {errors.website && touched.website ? (
                  <p className="help is-danger">{errors.website}</p>
                ) : null}
              </div>

              <div className="form-style-agile">
                <label>Store Location</label>
                <div className="pom-agile">
                  <span className="fa fa-map-marker"></span>
                  <input
                    type="text"
                    className="store"
                    placeholder="Store Location"
                    value={values.store_location || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="store_location"
                    disabled
                    required=""
                    style={{ filter: "opacity(0.6)" }}
                  />
                </div>
                {errors.store_location && touched.store_location ? (
                  <p className="help is-danger">{errors.store_location}</p>
                ) : null}
              </div>
              <div className="form-style-agile">
                <label>Regions</label>
                <div className="pom-agile">
                  <span className="fa fa-map-marker"></span>
                  <input
                    type="text"
                    placeholder="Regions"
                    value={values.regions || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="regions"
                    required=""
                  />
                </div>
                {errors.regions && touched.regions ? (
                  <p className="help is-danger">{errors.regions}</p>
                ) : null}
              </div>

              <div className="form-style-agile">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_API_GOOGLESITEKEY}
                  onloadcallback={onLoadRecaptcha}
                  verifycallback="verifyCallback"
                  name="captcha"
                  onChange={onChange}
                />
                {errorsCapMsg !== "" ? (
                  <p className="help is-danger">{errorsCapMsg}</p>
                ) : null}
              </div>
              {/* <div className="sub-agile">
              <input type="checkbox" id="brand1" value="" />
              <label htmlFor="brand1">
                <span></span>I Accept to the Terms & Conditions
              </label>
            </div> */}
              <input type="submit" value="Update" />
            </form>
          </div>
        </div>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <img
          src="https://res.cloudinary.com/sparkcloudsforewards/image/upload/v1692705802/loading_hosqnr.gif"
          alt="loading"
        />
      </div>
    </>
  );
}

export default EditStore;
